import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { ServiceProviderContact } from '../components/Contacts/ServiceProviderContact';
import ServiceProviderDndProviderComponent from '../components/Services/ServiceProviderDndProviderComponent';
import { ServiceProviderVenues } from '../components/Venues/ServiceProviderVenues';
import { ServiceProviderImages } from '../components/Images/ServiceProviderImages';
import { SPLinkField } from '../components/Table/fields/SPLinkField';
import { ServiceProviderCorporate } from '../components/LegalAndFinance/ServiceProviderCorporate';
import { ServiceProviderAttachment } from '../components/Images/ServiceProviderAttachment';
import { activityWithOutServiceProvider } from './activityWithOutServiceProvider';
import { ServiceProviderCustomFields } from '../components/Custom/ServiceProviderCustomFields';
import { Staff } from '../components/ServiceProvider/Staff';
import { Corporate } from '../components/ServiceProvider/Corporate';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SetField } from '../components/Table/fields/SetField';
import {SPSetUserField} from "../components/Table/fields/SPSetUserField";
import {userByRole} from "./userByRole";
import {Driver} from "../components/ServiceProvider/Driver";
import {EditableFields} from "../components/ServiceProvider/EditableFields";
import {Vehicle} from "../components/ServiceProvider/Vehicle";
import {RequiredFields} from "../components/ServiceProvider/RequiredFields";

export const serviceProvider: SchemaWithClient<any> = {
  name: 'Service Provider',
  pluralName: 'Service Providers',

  filters: {
    activity_category: {
      name: 'Category',
      schema: enumItems.activityCategory,
    },
    activity_types: {
      name: 'Type',
      schema: enumItems.activityType,
      wait: 'activity_category',
      multiSwitchboard: true,
    },
  },

  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 6,
      label: 'Corporate',
      name: 'corporates',
      type: 'custom',
      renderer: Corporate,
      rendererType: 'corporates',
    },
    {
      id: 2,
      label: 'Contacts',
      name: 'contacts',
      type: 'custom',
      renderer: ServiceProviderContact,
      rendererType: 'contacts',
    },
    {
      id: 3,
      label: 'Services',
      name: 'services',
      type: 'custom',
      renderer: ServiceProviderDndProviderComponent,
      rendererType: 'service',
    },
    {
      id: 4,
      label: 'Venues',
      name: 'venues',
      type: 'custom',
      renderer: ServiceProviderVenues,
      rendererType: 'venues',
    },
    {
      id: 5,
      label: 'Images',
      name: 'images',
      type: 'custom',
      renderer: ServiceProviderImages,
      rendererType: 'images',
    },
  ],

  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Service Provider',
              fieldRenderer: SPTextField,
            },
            {
              columnName: 'description',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
            {
              name: 'Availability',
              fieldRenderer: SPRichTextField,
              columnName: 'availability',
            },
            {
              name: 'Hotline',
              fieldRenderer: SPTextField,
              columnName: 'hotline',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              grid: true,
              columns: [
                {
                  name: 'Category',
                  fieldRenderer: SPSelectField.tableAdapter(
                    enumItems.activityCategory
                  ),
                  columnName: 'activity_category',
                },
                {
                  name: 'Type',
                  fieldRenderer: SPSetField.tableAdapter(
                    enumItems.activityType
                  ),
                  columnName: 'activity_types',
                },
              ],
            },

            {
              name: 'Activities',
              fieldRenderer: SPLinkField,
              columnName: 'activities',
              columnSchema: activityWithOutServiceProvider,
            },
            {
              name: 'Notes',
              fieldRenderer: SPRichTextField,
              columnName: 'notes',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Default provider',
              fieldRenderer: SPBooleanField,
              columnName: 'default_provider',
              type: 'boolean'
            },
            {
              name: "Don't Send Confirmation",
              fieldRenderer: SPBooleanField,
              columnName: 'dont_send_confirmation',
              type: 'boolean'
            },
            {
              name: "Confirm All Reservation",
              fieldRenderer: SPBooleanField,
              columnName: 'confirm_all',
              type: 'boolean'
            },
            {
              name: "Whatsapp Connection",
              fieldRenderer: SPBooleanField,
              columnName: 'whatsapp',
              type: 'boolean'
            },
            {
              name: 'Active',
              fieldRenderer: SPBooleanField,
              columnName: 'active',
              type: 'boolean'
            },
            {
              name: 'Automatic confirmation before (hours)',
              fieldRenderer: SPNumberField,
              columnName: 'automatic_confirmation_before_hours',
            },
            {
              name: 'Websites',
              fieldRenderer: SPRichTextField,
              columnName: 'website',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      width: 12,
      label: 'Contacts',
      name: 'contacts',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'contacts',
              fieldRenderer: ServiceProviderContact,
            },
          ],
        },
      ],
    },

    {
      id: 4,
      width: 12,
      label: 'Legal & Finance',
      name: 'corporates',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'corporates',
              fieldRenderer: ServiceProviderCorporate,
            },
          ],
        },
      ],
    },
    {
      id: 5,
      width: 12,
      label: 'Services',
      name: 'services',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'services',
              fieldRenderer: ServiceProviderDndProviderComponent,
            },
          ],
        },
      ],
    },
    {
      id: 10,
      width: 6,
      label: 'Event Staff',
      name: 'event_staff',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'event_staff',
              fieldRenderer: Staff,
            },
          ],
        },
      ],
    },
    {
      id: 11,
      width: 6,
      label: 'Drivers',
      name: 'drivers',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'drivers',
              fieldRenderer: Driver,
              columnSchema: userByRole("7")
            },
          ],
        },
      ],
    },
    {
      id: 13,
      width: 6,
      label: 'Vehicles',
      name: 'vehicles',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'vehicles',
              fieldRenderer: Vehicle,
              columnSchema: enumItems.vehicle
            },
          ],
        },
      ],
    },

    {
      id: 6,
      width: 6,
      label: 'Editable Provider Fields',
      name: 'editable_provider_fields',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'editable_provider_fields',
              fieldRenderer: EditableFields,
            },
          ],
        },
      ],
    },
    {
      id: 6,
      width: 6,
      label: 'Required Provider Fields',
      name: 'required_provider_fields',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'required_provider_fields',
              fieldRenderer: RequiredFields,
            },
          ],
        },
      ],
    },
    {
      id: 6,
      width: 12,
      label: 'Custom Fields',
      name: 'custom_fields',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'custom_field',
              fieldRenderer: ServiceProviderCustomFields,
            },
          ],
        },
      ],
    },

    {
      id: 7,
      width: 6,
      label: 'Attachments',
      name: 'attachments',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'attachments',
              fieldRenderer: ServiceProviderAttachment,
            },
          ],
        },
      ],
    },
    /* {
      id: 6,
      width: 6,
      label: 'Accommodation Information',
      name: 'accommodation_information',
      grids: [
        {
          width: 12,
          columns: [
            /!*{
              columnName: 'accommodation_information',
              fieldRenderer: ServiceProviderAccommodationInformation,
            },*!/
            {
              columnName: 'partner_price',
              name: 'Partner Price',
              fieldRenderer: SPBooleanField,
            },
            {
              columnName: 'partner_fix_price',
              name: 'Partner Fix Price',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'partner_fix_price_currency',
              name: 'Partner Fix Price Currency',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
            },
            {
              columnName: 'partner_discount',
              name: 'Discount',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'partner_price_description',
              name: 'Partner Price Description',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'breakfast_price',
              name: 'Breakfast Price',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'breakfast_price_currency',
              name: 'Partner Price',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
            },
          ],
        },
      ],
    },*/
    {
      id: 8,
      width: 6,
      label: 'Images',
      name: 'images',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'images',
              fieldRenderer: ServiceProviderImages,
            },
          ],
        },
      ],
    },

    {
      id: 9,
      width: 6,
      label: 'Venues',
      name: 'venues',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'venues',
              fieldRenderer: ServiceProviderVenues,
            },
          ],
        },
      ],
    },
  ],

  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      required: true,
      defaultShow: true,
    },
    description: {
      name: 'Description',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: true,
    },
    activity_category: {
      name: 'Category',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityCategory),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.activityCategory
      ),
      url: enumItems.activityCategory.client.getAllPath,
      tempSchema: enumItems.activityCategory,
      switchboard: true,
    },
    activity_types: {
      name: 'Types',
      fieldRenderer: SetField.tableAdapter(enumItems.activityType),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.activityType),
      url: enumItems.activityType.client.getAllPath,
      tempSchema: enumItems.activityType,
      multiSwitchboard: true,
    },
    drivers: {
      name: 'Drivers',
      fieldRenderer: SPSetUserField.tableAdapter(userByRole('7')),
      slidePaneFieldRenderer: Driver.tableAdapter(userByRole('7')),
      url: userByRole('7').client.getAllPath,
      tempSchema: userByRole('7'),
      multiSwitchboard: true,
    },
    vehicles: {
      name: 'Vehicles',
      fieldRenderer: SPSetField.tableAdapter(enumItems.vehicle),
      slidePaneFieldRenderer: Vehicle.tableAdapter(enumItems.vehicle),
      url: enumItems.vehicle.client.getAllPath,
      tempSchema: enumItems.vehicle,
      multiSwitchboard: true,
    },
    website: {
      name: 'Website',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: true,
    },
    hotline: {
      name: 'Hotline',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    automatic_confirmation_before_hours: {
      name: "Automatic confirmation before (hours)",
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    dont_send_confirmation: {
      name: "Don't Send Confirmation",
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    confirm_all: {
      name: "Confirm All Reservation",
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    whatsapp: {
      name: "Whatsapp Communication",
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      defaultShow: true,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      defaultShow: false,
    },
  },
  viewTable: 'service_providers',
  client: new Client(`/service-providers`),
};
